import { render, staticRenderFns } from "./BasketExpiry.vue?vue&type=template&id=ce999e8e&"
import script from "./BasketExpiry.vue?vue&type=script&lang=js&"
export * from "./BasketExpiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports